import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const costs = ['Tiempo perdido buscando respuestas en Google', 'Dinero gastado en errores que se pudieron evitar', 'Frustración de sentir que no avanzas', 'Negocios que mueren antes de empezar', 'Sueños que se quedan en conversaciones de WhatsApp'];
  return <section className="py-24 bg-white" data-id="element-234">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl mx-auto text-gray-700 font-sans" data-id="element-236">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-8 leading-tight" data-id="element-237">
            Registrar una empresa es&nbsp;fácil.
            <br data-id="element-238" />
            <span className="text-inkova-accent" data-id="element-239">
              Crearla bien es otra&nbsp;historia.
            </span>
          </h2>

          <p className="mb-6" data-id="element-240">
            Todos los días emprendedores latinos dan el paso. Registran su LLC.
            Obtienen su EIN. Sienten que ya están&nbsp;listos.
          </p>

          <p className="mb-8 font-medium text-inkova-primary text-xl" data-id="element-241">
            Y entonces llega la&nbsp;realidad:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="my-12 bg-inkova-light p-8 md:p-10 rounded-3xl border border-inkova-accent/20 shadow-sm" data-id="element-242">
          <div className="grid md:grid-cols-2 gap-6 text-gray-800 font-medium italic" data-id="element-243">
            <p className="flex items-start" data-id="element-244">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-245">
                ?
              </span>
              ¿Cómo abro mi cuenta bancaria?
            </p>
            <p className="flex items-start" data-id="element-246">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-247">
                ?
              </span>
              ¿Qué es el Annual Report y cuándo lo presento?
            </p>
            <p className="flex items-start" data-id="element-248">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-249">
                ?
              </span>
              ¿Necesito un Operating Agreement?
            </p>
            <p className="flex items-start" data-id="element-250">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-251">
                ?
              </span>
              ¿Qué estructura elegir?
            </p>
            <p className="flex items-start" data-id="element-252">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-253">
                ?
              </span>
              ¿Cómo cumplir con el IRS?
            </p>
            <p className="flex items-start" data-id="element-254">
              <span className="text-inkova-accent mr-3 font-bold not-italic" data-id="element-255">
                ?
              </span>
              ¿Qué necesitas para operar correctamente?
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl mx-auto text-gray-700 font-sans" data-id="element-256">
          <p className="mb-6 font-bold text-inkova-dark text-xl" data-id="element-257">
            La empresa existe en papel. Pero el negocio… todavía no existe
            en&nbsp;la&nbsp;realidad.
          </p>

          <p className="mb-6" data-id="element-258">
            Y no porque no tengas talento. No porque no
            tengas&nbsp;la&nbsp;idea.
          </p>

          <p className="mb-10 text-inkova-primary font-medium" data-id="element-259">
            Sino porque nadie te explicó qué hacer
            después&nbsp;del&nbsp;registro.
          </p>

          <div className="mb-12" data-id="element-260">
            <p className="font-bold text-gray-900 mb-6" data-id="element-261">
              Eso tiene un costo&nbsp;real:
            </p>
            <div className="space-y-4" data-id="element-262">
              {costs.map((cost, i) => <div key={i} className="flex items-start" data-id="element-263">
                  <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-264" />
                  <span className="text-gray-700" data-id="element-265">{cost}</span>
                </div>)}
            </div>
          </div>

          <blockquote className="border-l-4 border-inkova-accent pl-6 py-4 bg-inkova-light rounded-r-xl shadow-sm italic text-inkova-primary font-serif text-xl md:text-2xl mt-12" data-id="element-266">
            "El talento no es suficiente si no hay&nbsp;estructura."
            <footer className="text-sm font-sans font-bold text-gray-500 mt-4 not-italic uppercase tracking-wider" data-id="element-267">
              — Annysol Navarro, Fundadora ·&nbsp;Inkova&nbsp;LLC
            </footer>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}